// dataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios"; // You might need to install axios: npm install axios
import { baseUrl } from "config";

const getProduct = "/getItemNames";
// Define the initial state
const initialState = {
  data: [],
  status: "idle",
  error: null,
};

// Define the thunk for fetching data from the API
export const fetchData = createAsyncThunk("data/fetchData", async () => {
  try {
    let isAvrgCostEnabled = false;
    try {
      const configResponse = await axios.post(
        baseUrl + "/getStockCheck",
        { params: "AVRG_COST" },
        {
          withCredentials: true,
        },
      );
      isAvrgCostEnabled = configResponse.data?.value === "YES";
    } catch (configError) {
      console.error(
        "Failed to fetch AVRG_COST config:",
        configError.message,
      );
    }

    const response = await axios.get(baseUrl + getProduct, {
      withCredentials: true,
    });

    let result = response.data.result;
    if (isAvrgCostEnabled) {
      result = result.map((item) => ({
        ...item,
        Cost:
          item.avrg_cost !== undefined && item.avrg_cost !== null
            ? item.avrg_cost
            : item.Cost,
        cost:
          item.avrg_cost !== undefined && item.avrg_cost !== null
            ? item.avrg_cost
            : item.cost,
      }));
      response.data.result = result;
    }

    return response.data;
  } catch (error) {
    // Handle errors
    throw error;
  }
});

// Define the data slice
const productDataSlice = createSlice({
  name: "ProductsData",
  initialState,
  reducers: {
    // Additional reducers can be defined here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.status = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.status = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.status = "failed to fetch product";
        state.error = action.error.message;
      });
  },
});

export default productDataSlice.reducer;
